export const MODES = { COLLECT: '1', PURCHASE: '2' }

export const QUERY_TYPE_VALUE = {
  all: 3,
  owned: 1,
  cooperative: 2,
  collected: 4,
}

export const queryTypeList = [
  { label: '全部', value: QUERY_TYPE_VALUE.all, type: 'tab' },
  { label: '我拥有的', value: QUERY_TYPE_VALUE.owned, type: 'tab' },
  { label: '我协作的', value: QUERY_TYPE_VALUE.cooperative, type: 'tab' },
  { label: '已采集', value: QUERY_TYPE_VALUE.collected, type: 'tab' },
]
